/*
 * @Author: changcheng
 * @LastEditTime: 2023-03-31 11:25:27
 */
import React, { useEffect, FC } from "react";
import { connect } from "react-redux";

import "./index.less";

const Link: FC<DefaultProps> = ({ history }) => {
  useEffect(() => {}, []);

  return (
    <div className={"link-module"}>
      <div className={"home-title-bar"}>
        <span className={"title"}>友情链接</span>
      </div>
      <div className={"link-list"}>
        <ul>
          <a href="http://www.nhc.gov.cn/" target="_blank" rel="nofollow">
            国家卫健委
          </a>
          <a href="http://www.nhfpc.gov.cn/" target="_blank" rel="nofollow">
            国家卫生和计划生育委员会
          </a>
          <a href="http://www.satcm.gov.cn/" target="_blank" rel="nofollow">
            国家中医药管理局
          </a>
          <a
            href="http://www.sda.gov.cn/WS01/CL0001/"
            target="_blank"
            rel="nofollow"
          >
            国家食品药品监督管理局
          </a>
          <a href="http://www.moe.gov.cn/" target="_blank" rel="nofollow">
            国家教育部
          </a>
          <a href="http://www.sarft.gov.cn/" target="_blank" rel="nofollow">
            国家新闻出版广电总局
          </a>
          <a href="http://www.21wecan.com/" target="_blank" rel="nofollow">
            中国卫生人才网
          </a>
          <a href="http://www.nmec.org.cn/" target="_blank" rel="nofollow">
            国家医学考试网
          </a>
          <a href="http://www.nihe.org.cn/" target="_blank" rel="nofollow">
            中国健康教育中心
          </a>
          <a href="http://www.cma.org.cn/" target="_blank" rel="nofollow">
            中华医学会
          </a>
          <a href="http://www.cmda.net/" target="_blank" rel="nofollow">
            中国医师协会
          </a>
          <a href="http://www.cndent.com/" target="_blank" rel="nofollow">
            中华口腔医学会
          </a>
          <a href="http://www.cacm.org.cn/" target="_blank" rel="nofollow">
            中华中医药学会
          </a>
          <a href="http://www.caca.org.cn/" target="_blank" rel="nofollow">
            中国抗癌协会
          </a>
          <a href="http://www.cpam.org.cn/" target="_blank" rel="nofollow">
            中国医疗保健国际交流促进会
          </a>
          <a href="http://www.cptcm.com/" target="_blank" rel="nofollow">
            中国中医药出版社
          </a>
        </ul>
      </div>
    </div>
  );
};

export default connect((state) => state)(Link);
